// extracted by mini-css-extract-plugin
export default {"container":"JourneyReviews_container__2OpfJ"};